module.exports = {"442000001":"石岐区街道办事处","442000002":"东区街道办事处","442000003":"火炬开发区街道办事处","442000004":"西区街道办事处","442000005":"南区街道办事处","442000006":"五桂山街道办事处","442000100":"小榄镇","442000101":"黄圃镇","442000102":"民众镇","442000103":"东凤镇","442000104":"东升镇","442000105":"古镇镇","442000106":"沙溪镇","442000107":"坦洲镇","442000108":"港口镇","442000109":"三角镇","442000110":"横栏镇","442000111":"南头镇","442000112":"阜沙镇","442000113":"南朗镇","442000114":"三乡镇","442000115":"板芙镇","442000116":"大涌镇","442000117":"神湾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/442000.json
// module id = 2181
// module chunks = 0